module.exports = __webpack_public_path__ + "img/img-4.e566c84d.jpg";